<template>
    <div class="page-sale-detail">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">報表統計</div>
			
            <div class="breadcrumb-item">銷售明細</div>
        </div>

        <div class="card-block">
            <Form inline class="pg-form-inline">
                <!-- <FormItem>
                    <Select size="small" placeholder="選擇倉庫">
                        <Option value="1">全部倉庫</Option>
                    </Select>
                </FormItem> -->
                <FormItem>
                    <Select size="small" placeholder="提貨櫃點" v-model="form.arrive">
                        <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
                                :key="item.ReceivingID">({{item.cainiao_match}}) {{item.ReceivingName}}
                        </Option>
                    </Select>
                </FormItem>
                <!-- <FormItem>
                    <Select size="small" placeholder="包裹類型" v-model="form.goods_type">
                        <Option :value="item.id" v-for="(item, index) in packageType"
                                :key="item.id">
                            {{item.start + '-' + item.end + (item.describe? (' (' + item.describe + ') ') :
                            '')}}
                        </Option>
                    </Select>
                </FormItem> -->
                <!-- <FormItem>
                    <Select size="small" placeholder="訂單類型">
                        <Option value="0">請選擇</Option>
                        <Option value="1">寄付</Option>
                        <Option value="2">到付</Option>
                        <Option value="3">代收</Option>
                    </Select>
                </FormItem> -->
                <FormItem>
                    <Select size="small" placeholder="收件方式" v-model="form.arrive_type">
                        <Option value="1">門店</Option>
                        <Option value="2">智能櫃</Option>
                    </Select>
                </FormItem>
                <!-- <FormItem>
                    <Select size="small" placeholder="操作人" v-model="form.admin_id">
                    	<Option :value="item.user_id" v-for="(item, index) in pickAdmin"
                    	        :key="item.user_id">{{item.username}}
                    	</Option>
                    </Select>
                </FormItem> -->
                <FormItem>
                    <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false" placeholder="珠海倉庫入庫-開始日期" value-format="yyyy-MM-dd hh:mm:ss" style="width: 100%;" :editable="false" v-model="form.start_time"></DatePicker>
                </FormItem>
                <FormItem>-</FormItem>
                <FormItem>
                    <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false" placeholder="珠海倉庫入庫-結束日期" value-format="yyyy-MM-dd hh:mm:ss" style="width: 100%;" :editable="false" v-model="form.end_time"></DatePicker>
                </FormItem>
            </Form>

            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <label class="input-label">快遞單號</label>
                    <Input size="small" v-model="form.odd_numbers" @keyup.enter.native="handleSearch()"></Input>
                </FormItem>
                <FormItem>
                    <label class="input-label">客戶名稱</label>
                    <Input size="small" v-model="form.recipient_contacts" @keyup.enter.native="handleSearch()"></Input>
                </FormItem>
                <FormItem>
                    <label class="input-label">客戶電話</label>
                    <Input size="small" v-model="form.phone" @keyup.enter.native="handleSearch()"></Input>
                </FormItem>
                <FormItem>
                    <label class="input-label">袋號</label>
                    <Input size="small" v-model="form.sack_number" @keyup.enter.native="handleSearch()"></Input>
                </FormItem>
                <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1" @click="handleSearch">搜索</div>
                        <div class="pg-btn style2" @click="handleExport">導出excel</div>
                    </div>
                </FormItem>
            </Form>
        </div>

        <div class="card-block pd-bt">
			<Spin fix class="pg-sub-loading" v-if="isSubmiting">
			    <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
			    <div class="loading-text">Loading</div>
			</Spin>
            <Table size="small"
				   no-data-text="暫無數據"
                   border
                   :columns="table.column"
                   :data="table.data">
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="12" class="pagger-left">
                    <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                    <div class="pagger-sizer">
                        <span>每頁</span>
                        <Select v-model="curPageSize" size="small" placeholder="數量">
                            <Option :value="10">10</Option>
                            <Option :value="20">20</Option>
                            <Option :value="30">30</Option>
                            <Option :value="40">40</Option>
                            <Option :value="50">50</Option>
                        </Select>
                    </div>

                    <div class="pagger-elevator">
                        <span>跳轉</span>
                        <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                               @on-enter="handlePageEnter"/>
                    </div>
                    
                    <Page size="small"
                          :current="pageIndex"
                          :page-size="curPageSize"
                          :total="totalCount"
                          @on-change="handlePageChange">
                    </Page>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>
<script>
	import axios from 'axios';
    export default {
        data() {
            return {
                pageIndex: 1,   //页码
                curPageSize: 10,    //一页数量
                totalCount: 1, //总条数
                money: 0,
                sum: 0,
                pageInput: '',  //输入的页码
                pickAddress: [],    //提貨櫃點
                packageType: [],    //包裹類型
                pickAdmin: [],
                form: {
                    arrive: '',    //提货柜点
                    arrive_type: '',    //收件方式，1门店，2智能柜
                    goods_type: '', //包裹类型
                    start_time: '',
                    end_time: '',
                    recipient_contacts: '', //客户名称
                    phone: '',  //客户手机号
                    odd_numbers: '',    //快递单号
                    sack_number: '',    //袋号
                	admin_id: ''
                },
                isSubmiting: false,
                // isLoading: true,
                exportLink: '', //导出地址
                table: {
                    column: [
                        // {
                        //     type: 'selection',
                        //     minWidth: 60,
                        //     align: 'center',
                        // },
                        {
                            title: '客戶名稱',
                            key: 'name',
                            align: 'center',
							sortable: true,
                            minWidth: 130
                        },
						{
						    title: '電話',
						    key: 'phone',
						    align: 'center',
							sortable: true,
						    minWidth: 130
						},
                        {
                            title: '添加時間',
                            key: 'datetime',
                            align: 'center',
							sortable: true,
                            minWidth: 160
                        },
                        {
                            title: '品名',
                            key: 'productName',
                            align: 'center',
							sortable: true,
                            minWidth: 110
                        },
                        {
                            title: '快遞單號',
                            key: 'orderNo',
                            align: 'center',
							sortable: true,
                            minWidth: 150
                        },
						{
						    title: '袋號',
						    key: 'sack_number',
						    align: 'center',
							sortable: true,
						    minWidth: 150
						},
                        {
                            title: '提貨櫃點',
                            key: 'address',
                            align: 'center',
                            sortable: true,
                            minWidth: 120
                        },
                        {
                            title: '重量',
                            key: 'weight',
                            align: 'center',
							sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '首重',
                            key: 'weight2',
                            align: 'center',
							sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '續重',
                            key: 'weight3',
                            align: 'center',
							sortable: true,
                            minWidth: 100
                        },
						{
						    title: '付款情況',
						    key: 'pay',
						    align: 'center',
							sortable: true,
						    minWidth: 150
						},
						{
						    title: '備註',
						    key: 'remarks',
						    align: 'center',
							sortable: true,
						    minWidth: 150
						},
                        // {
                        //     title: '成本首重',
                        //     key: 'firstWeight',
                        //     align: 'center',
                        //     minWidth: 100
                        // },
                        // {
                        //     title: '成本續重',
                        //     key: 'lastWeight',
                        //     align: 'center',
                        //     minWidth: 100
                        // },
                        // {
                        //     title: '成本附加費',
                        //     key: 'attachFee',
                        //     align: 'center',
                        //     minWidth: 100
                        // },
                        // {
                        //     title: '成本合計',
                        //     key: 'totalFee',
                        //     align: 'center',
                        //     minWidth: 100
                        // },
                        // {
                        //     title: '利潤',
                        //     key: 'profit',
                        //     align: 'center',
                        //     minWidth: 100
                        // },
                        // {
                        //     title: '提成收入(按分成比例)',
                        //     key: 'rate',
                        //     align: 'center',
                        //     minWidth: 160
                        // },
                        
                    ],
                    data: []
                }
            };
        },
        mounted() {
			this.getPickAddress();
			this.getPackageType();
			this.getPickAdmin();
        },
		watch: {
			curPageSize() {
				this.getList();
			}
		},
        methods: {
            //提貨櫃點
            getPickAddress() {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAddress,
                    method: 'get',
                    data: {
                        company_id: 1,
                    }
                }).then((res) => {
                    if (res.code == 0) {
                        this.pickAddress = res.data.data;
						this.getList();
                    }
                });
            },
            //操作人
            getPickAdmin() {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAdmin,
                    method: 'post'
                }).then((res) => {
                    if (res.code == 0) {
                        this.pickAdmin = res.data.data;
                    }
                });
            },
            //包裹類型
            getPackageType() {
                this.$Rq.requestAuth({
                    url: this.$Api.packageType,
                    method: 'get'
                }).then((res) => {
                    if (res.code == 0) {
                        this.packageType = res.data.data;
                    }
                });
            },
            getList() {
                let form = this.form;
                // this.isLoading = true;
				this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.scanIn,
                    method: 'get',
                    data: {
                        status: '',  //0待出库, 1已出库
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                        arrive: form.arrive,
                        arrive_type: form.arrive_type,
                        goods_type: form.goods_type,
                        start_time: this.formatDate(form.start_time),
                        end_time: this.formatDate(form.end_time),
                        recipient_contacts: form.recipient_contacts,
                        phone: form.phone,
                        odd_numbers: form.odd_numbers,
                        sack_number: form.sack_number,
            			admin_id: form.admin_id
                    }
                }).then((res) => {
                    // this.isLoading = false;
					this.isSubmiting = false;
                    if (res.code == 0) {
                        let tempArr = [];
                        let resData = res.data.data;
                        for (let i = 0; i < resData.length; i++) {
            				// firstWeight: 4,
            				// lastWeight: 2,
            				// attachFee: 0,
            				// totalFee: 4,
            				// profit: 2,
            				// rate: 1,
            				// pay: '待付'
                            tempArr.push({
                                id: resData[i].id,
                                name: resData[i].recipient_contacts,
                                datetime: resData[i].created_at,
                                productName: resData[i].detailed.name,
                                address: resData[i].store ? resData[i].store.ReceivingName : '無',
            					orderNo: resData[i].odd_numbers,
            					weight: resData[i].weight,
                                weight2: 1,
            					weight3: (resData[i].weight-1) < 0 ? 0:Math.round(resData[i].weight-1),
								pay: resData[i].pay_status == 0? '待付':'已付',
								remarks: resData[i].remarks,
								sack_number: resData[i].sack_number,
								phone: resData[i].recipient_phone
                            });
                        }
                        this.totalCount = res.data.count;
            			this.sum = Math.round(res.data.sum);
            			this.money = Math.round(res.data.money);
                        this.table.data = tempArr;
                    }
                }).catch((err) => {
					this.isSubmiting = false;
                    // this.isLoading = false;
                });
            },
            handleSearch() {
                this.pageIndex = 1;
                this.getList();
            },
			formatDate(datetime)
			{
			    if (!datetime) return '';
			    let dateTime = new Date(datetime);
			    let year = dateTime.getFullYear();
			    let month = dateTime.getMonth() + 1;
			    let date = dateTime.getDate();
			    let hour = dateTime.getHours();
			    let minute = dateTime.getMinutes();
			    let second = dateTime.getSeconds();
				let milliseconds = dateTime.getMilliseconds();
			    return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
			},
			formatNum(num)
			{
			    return num < 10 ? '0' + num : num;
			},
            handleExport() {
                let token = localStorage.getItem('jyb_token');
                let form = this.form;
                let params = {
                    'Authorization': token,
            		flag: 1,
                    status: -1,  //全部
                    arrive: form.arrive,
                    arrive_type: form.arrive_type,
                    goods_type: form.goods_type,
                    start_time: this.formatDate(form.start_time),
                    end_time: this.formatDate(form.end_time),
                    recipient_contacts: form.recipient_contacts,
                    phone: form.phone,
                    odd_numbers: form.odd_numbers,
                    sack_number: form.sack_number,
            		admin_id: form.admin_id
                };
                let formatParams = this.$Utils.formateObjToParamStr(params);
				// window.open(`${this.$Api.deliverFexport}?${formatParams}`, '_blank');
				if(form.start_time == ''){
					this.$Utils.showTipInfo("請選擇起始時間");
				}
				else if(form.end_time == ''){
					this.$Utils.showTipInfo("請選擇結束時間");
				}
				else{
                    this.getList();
					window.open(`${this.$Api.deliverFexport}?${formatParams}`, '_blank');
					this.exportLink = `${this.$Api.deliverFexport}?${formatParams}`;
				}
            },
            handlePageSizeChange(value) {
                this.pageIndex = 1;
                this.getList();
            },
            handlePageInput() {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount) {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter() {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0) {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },
            handlePageChange(value) {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "SaleDetail.scss";
</style>